<button
  type="button"
  class="btn-impressao"
  [disabled]="disabled"
  [class.esmaecido]="esmaecido"
  (click)="onClick()"
>
<p>Exportar Excel</p>

  <img *ngIf="icon" [src]="icon" alt="Ícone de Excel" />
</button>
